import {
  MenuItem,
  MenuSelect,
  SortDescendingMd,
  mediaHelper,
  paletteHelper,
  spacingHelper,
  typographyHelper,
} from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  .triggerButton {
    color: ${paletteHelper('textSecondary')};
    /* This spacing and negative left margin is to ensure the text lines up
      but also ensures we still have a focus border
      Discussed with Sam on 20/09/23 */
    padding: 0 ${spacingHelper('small')};
    position: relative;
    left: calc(${spacingHelper('small')} * -1);

    &:hover {
      background: none;
      color: ${paletteHelper('textPrimary')};
    }
  }
  .buttonLabel {
    ${typographyHelper('body02')};
    color: inherit;
  }
  .list {
    margin-block: 0;
  }
`;

const StyledMenuItem = styled(MenuItem)<{ $isHighLight: boolean }>`
  ${typographyHelper('subtitle02')};

  color: ${({ $isHighLight }) =>
    $isHighLight ? paletteHelper('textPrimary') : paletteHelper('textSecondary')};
  &:hover {
    background-color: ${paletteHelper('backgroundSecondary')};
  }
  .layoutContainer {
    align-items: center;
  }

  .menuItemLabel {
    ${typographyHelper('subtitle02')};
  }
`;

export interface SearchSortItem {
  label: string;
  value: string;
}
export interface SearchStickySortMenuSelectProps {
  options: SearchSortItem[];
  selectedItem: SearchSortItem;
  setSelectedItem: (selectedItem: SearchSortItem) => void;
  id: string;
}
const FullLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacingHelper('extraSmall')};

  ${mediaHelper('mobile')} {
    display: none;
  }
`;
const ShortLabel = styled.div`
  display: none;
  ${mediaHelper('mobile')} {
    display: block;
  }
  ${mediaHelper('mobileSmall')} {
    display: none;
  }
`;
const ExtraShortLabel = styled.div`
  display: none;

  ${mediaHelper('mobileSmall')} {
    display: block;
  }
`;
const MenuButtonLabel = ({ label }: { label: string }) => (
  <>
    <FullLabel>
      <SortDescendingMd /> {label}
    </FullLabel>
    <ShortLabel>{label}</ShortLabel>
    <ExtraShortLabel>Sort</ExtraShortLabel>
  </>
);

export const SearchStickySortMenuSelect: FunctionComponent<SearchStickySortMenuSelectProps> = ({
  options,
  selectedItem,
  setSelectedItem,
  id,
}) => {
  const onSortByChanged = ({ label, value }: { label: string; value: string }) =>
    setSelectedItem({ label, value });
  return (
    <Wrapper>
      <MenuSelect
        id={id}
        selectedItem={selectedItem.label}
        placement="bottom-start"
        buttonProps={{
          children: <MenuButtonLabel label={selectedItem.label} />,
        }}
        dangerouslySetClassNames={{
          triggerButton: 'triggerButton',
          list: 'list',
          buttonClassNames: {
            label: 'buttonLabel',
          },
        }}
      >
        {() => (
          <>
            {options.map(({ label, value }) => {
              return (
                <StyledMenuItem
                  onClick={() => onSortByChanged({ label, value })}
                  $isHighLight={selectedItem.value === value}
                  dangerouslySetClassNames={{
                    label: 'menuItemLabel',
                    layoutContainer: 'layoutContainer',
                  }}
                  key={value}
                  tabIndex={0}
                  onTouchEnd={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onSortByChanged({ label, value });
                  }}
                >
                  {label}
                </StyledMenuItem>
              );
            })}
          </>
        )}
      </MenuSelect>
    </Wrapper>
  );
};
